import React from 'react'
import ErrorBoundary from './components/ErrorBoundary'
import Header from './components/Header'
import Hero from './components/Hero'
import SocialProof from './components/SocialProof'
import Transformation from './components/Transformation'
import Features from './components/Features'
import DashboardPreview from './components/DashboardPreview'
import WhyLaundryMate from './components/WhyLaundryMate'
import Pricing from './components/Pricing'
import RiskReversal from './components/RiskReversal'
import Testimonials from './components/Testimonials'
import FAQ from './components/FAQ'
import CTASection from './components/CTASection'
import Footer from './components/Footer'
import StickyCTA from './components/StickyCTA'
import ChatBot from './components/ChatBot'
import { ThemeProvider } from './context/ThemeContext'

function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
          <Header />
          <Hero />
          <SocialProof />
          <Transformation />
          <Features />
          <DashboardPreview />
          <WhyLaundryMate />
          <Pricing />
          <RiskReversal />
          <Testimonials />
          <FAQ />
          <CTASection />
          <Footer />
          <StickyCTA />
          <ChatBot />
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
